import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';
import { FlexStack } from '~/components/atomic';
import CreatorTag from '~/components/common/CharacterCard/CreatorTag/CreatorTag';
import { useGetExploreCharacterListQuery } from '~/features/character';
import { useCreateChatRoom } from '~/hooks';
import { SECOND } from '~/constants';
import * as S from './CharacterBanner.styled';
import SuspenseImage from './SuspenseImage';

export default function CharacterBanner() {
  const { data } = useGetExploreCharacterListQuery();
  const { handleCreateRoomClick } = useCreateChatRoom();

  return (
    <>
      <S.BannerSwiper
        loop={true}
        modules={[Autoplay, Pagination]}
        autoplay={{
          delay: 5 * SECOND,
          disableOnInteraction: false,
        }}
        slidesPerView={1.1}
        spaceBetween={12}
        centeredSlides={true}
      >
        {data.map(
          (
            {
              character_id,
              character_name,
              character_desc,
              create_username,
              character_image,
              type,
            },
            index,
          ) => (
            <S.BannerSlide
              key={character_id}
              onClick={() =>
                handleCreateRoomClick({
                  id: character_id,
                  type,
                  image: character_image,
                })
              }
            >
              {index === 0 || index === 1 ? (
                <SuspenseImage url={character_image} />
              ) : (
                <img src={character_image} alt='character thumbnail' />
              )}
              <S.BannerBackground />
              <S.BannerSlideDetail>
                <FlexStack spacing={8}>
                  <CreatorTag create_username={create_username} />
                  <p className='name'>{character_name}</p>
                  <p className='detail'>{character_desc}</p>
                </FlexStack>

                <S.StyledChatButton
                  isLeftIcon
                  leftIconName='Chat'
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCreateRoomClick({
                      id: character_id,
                      type,
                      image: character_image,
                    });
                  }}
                >
                  chat
                </S.StyledChatButton>
              </S.BannerSlideDetail>
            </S.BannerSlide>
          ),
        )}
      </S.BannerSwiper>
    </>
  );
}
